import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "../pages/Login.css";

/**
 * Turns the backend's reason code into a sentence a person can act on.
 *
 * The callback deliberately sends only a short code, never Microsoft's own
 * error text: that text is authored elsewhere and reflecting it unvalidated
 * would be an injection sink. An unrecognised code therefore falls back to the
 * generic message rather than being rendered.
 */
const MESSAGES = {
  tenant_not_linked: {
    title: "Microsoft sign-in isn't set up yet",
    body:
      "Your organisation hasn't connected Microsoft sign-in. Ask your " +
      "administrator to link it in Settings → Single sign-on.",
  },
  pending: {
    title: "Waiting for approval",
    body:
      "Your administrator needs to approve your access. They can see your " +
      "request now, try again shortly.",
  },
  blocked: {
    title: "Access revoked",
    body: "Your access has been revoked. Contact your administrator.",
  },
  invalid_state: {
    title: "That link has expired",
    body: "That sign-in link has expired. Please try again.",
  },
  invalid_request: {
    title: "Something was missing",
    body: "That sign-in link was incomplete. Please try again.",
  },
  provider_error: {
    title: "Microsoft couldn't sign you in",
    body: "Microsoft couldn't complete the sign-in. Please try again.",
  },
  tenant_taken: {
    title: "Directory already connected",
    body:
      "That Microsoft directory is already connected to another " +
      "organisation. Contact support if you think this is wrong.",
  },
  handoff_failed: {
    title: "Almost there",
    body:
      "We couldn't finish signing you in. Please try again, sign-in " +
      "links are single-use and expire after a minute.",
  },
};

const FALLBACK = {
  title: "Something went wrong",
  body: "Something went wrong signing you in. Please try again.",
};

const SsoError = () => {
  const [params] = useSearchParams();

  useEffect(() => {
    document.body.classList.add("nx-onboard-body");
    return () => document.body.classList.remove("nx-onboard-body");
  }, []);

  // Look the code up; never render it.
  const { title, body } = MESSAGES[params.get("reason")] ?? FALLBACK;

  return (
    <div className="nx-login-page">
      <div className="nx-content">
        <div className="nx-login-card nx-sso-status">
          <div className="nx-card-header">
            <img
              src="/images/NexOpta-Logo.png"
              alt="Nexopta"
              className="nx-card-logo"
            />
          </div>

          <h1 className="nx-sso-error-title">{title}</h1>
          <p className="nx-sso-status-text">{body}</p>

          <div className="nx-login-links">
            <p>
              <Link to="/login">Back to sign in</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SsoError;
